import { render } from "./QuestionsDetails.vue?vue&type=template&id=494fc6ba"
import script from "./QuestionsDetails.vue?vue&type=script&lang=js"
export * from "./QuestionsDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__